import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faImage, faPalette, faPaintBrush, faCamera, faVideo, faMagic,
  faHeart, faStar, faFire, faBolt, faGem, faCrown,
  faMusic, faFilm, faMicrophone, faHeadphones, faGuitar, faDrum,
  faShoppingCart, faShoppingBag, faGift, faTag, faPercent, faDollarSign,
  faUtensils, faCoffee, faPizzaSlice, faIceCream, faCookie, faBirthdayCake,
  faHome, faBuilding, faStore, faSchool, faHospital, faChurch,
  faCar, faBicycle, faMotorcycle, faTrain, faPlane, faRocket,
  faBook, faGraduationCap, faPen, faPencil, faMarker, faHighlighter,
  faSun, faMoon, faCloud, faSnowflake, faUmbrella, faCloudRain,
  faDog, faCat, faDove, faFish, faHorse, faDragon,
  faLeaf, faTree, faSeedling, faMountain, faWater,
  faTshirt, faHatCowboy, faGlasses, faSocks,
  faGamepad, faDice, faPuzzlePiece, faChess, faBaseball, faFootball,
  faMedal, faTrophy, faAward, faCertificate, faRibbon, faMedkit,
  faSmile, faLaugh, faGrinStars, faKiss, faHandshake,
  faBrush, faShapes, faIcons, faLightbulb, faWandMagicSparkles, faPenNib, faFeather,
  faCakeCandles, faBell, faMugHot, faCandyCane, faHollyBerry,
  faBurger, faAppleAlt, faCarrot, faTags, faReceipt, faBarcode,
  faCity, faShip, faCalculator, faFlask, faMicroscope,
  faHammer, faWrench, faScrewdriver, faPaintRoller, faScrewdriverWrench, faToolbox,
  faSpa, faBug, faShirt, faRing, faClock, faShoePrints,
  faSoccerBall, faBasketball, faVolleyball, faDumbbell, faCreditCard, faCube
} from '@fortawesome/free-solid-svg-icons';

export interface IconOption {
  readonly name: string;
  readonly icon: IconDefinition;
  readonly label: string;
  readonly category: string;
}

export const ICON_OPTIONS: IconOption[] = [
  // Arte & Design
  { name: 'faImage', icon: faImage, label: 'Imagem', category: 'Arte & Design' },
  { name: 'faPalette', icon: faPalette, label: 'Paleta', category: 'Arte & Design' },
  { name: 'faPaintBrush', icon: faPaintBrush, label: 'Pincel', category: 'Arte & Design' },
  { name: 'faCamera', icon: faCamera, label: 'Câmera', category: 'Arte & Design' },
  { name: 'faVideo', icon: faVideo, label: 'Vídeo', category: 'Arte & Design' },
  { name: 'faMagic', icon: faMagic, label: 'Mágica', category: 'Arte & Design' },

  // Emoções & Símbolos
  { name: 'faHeart', icon: faHeart, label: 'Coração', category: 'Emoções & Símbolos' },
  { name: 'faStar', icon: faStar, label: 'Estrela', category: 'Emoções & Símbolos' },
  { name: 'faFire', icon: faFire, label: 'Fogo', category: 'Emoções & Símbolos' },
  { name: 'faBolt', icon: faBolt, label: 'Raio', category: 'Emoções & Símbolos' },
  { name: 'faGem', icon: faGem, label: 'Gema', category: 'Emoções & Símbolos' },
  { name: 'faCrown', icon: faCrown, label: 'Coroa', category: 'Emoções & Símbolos' },

  // Música & Áudio
  { name: 'faMusic', icon: faMusic, label: 'Música', category: 'Música & Áudio' },
  { name: 'faFilm', icon: faFilm, label: 'Filme', category: 'Música & Áudio' },
  { name: 'faMicrophone', icon: faMicrophone, label: 'Microfone', category: 'Música & Áudio' },
  { name: 'faHeadphones', icon: faHeadphones, label: 'Fones', category: 'Música & Áudio' },
  { name: 'faGuitar', icon: faGuitar, label: 'Guitarra', category: 'Música & Áudio' },
  { name: 'faDrum', icon: faDrum, label: 'Bateria', category: 'Música & Áudio' },

  // Comércio
  { name: 'faShoppingCart', icon: faShoppingCart, label: 'Carrinho', category: 'Comércio' },
  { name: 'faShoppingBag', icon: faShoppingBag, label: 'Sacola', category: 'Comércio' },
  { name: 'faGift', icon: faGift, label: 'Presente', category: 'Comércio' },
  { name: 'faTag', icon: faTag, label: 'Etiqueta', category: 'Comércio' },
  { name: 'faPercent', icon: faPercent, label: 'Desconto', category: 'Comércio' },
  { name: 'faDollarSign', icon: faDollarSign, label: 'Dinheiro', category: 'Comércio' },

  // Comida & Bebida
  { name: 'faUtensils', icon: faUtensils, label: 'Talheres', category: 'Comida & Bebida' },
  { name: 'faCoffee', icon: faCoffee, label: 'Café', category: 'Comida & Bebida' },
  { name: 'faPizzaSlice', icon: faPizzaSlice, label: 'Pizza', category: 'Comida & Bebida' },
  { name: 'faIceCream', icon: faIceCream, label: 'Sorvete', category: 'Comida & Bebida' },
  { name: 'faCookie', icon: faCookie, label: 'Biscoito', category: 'Comida & Bebida' },
  { name: 'faBirthdayCake', icon: faBirthdayCake, label: 'Bolo', category: 'Comida & Bebida' },

  // Lugares
  { name: 'faHome', icon: faHome, label: 'Casa', category: 'Lugares' },
  { name: 'faBuilding', icon: faBuilding, label: 'Prédio', category: 'Lugares' },
  { name: 'faStore', icon: faStore, label: 'Loja', category: 'Lugares' },
  { name: 'faSchool', icon: faSchool, label: 'Escola', category: 'Lugares' },
  { name: 'faHospital', icon: faHospital, label: 'Hospital', category: 'Lugares' },
  { name: 'faChurch', icon: faChurch, label: 'Igreja', category: 'Lugares' },

  // Transporte
  { name: 'faCar', icon: faCar, label: 'Carro', category: 'Transporte' },
  { name: 'faBicycle', icon: faBicycle, label: 'Bicicleta', category: 'Transporte' },
  { name: 'faMotorcycle', icon: faMotorcycle, label: 'Moto', category: 'Transporte' },
  { name: 'faTrain', icon: faTrain, label: 'Trem', category: 'Transporte' },
  { name: 'faPlane', icon: faPlane, label: 'Avião', category: 'Transporte' },
  { name: 'faRocket', icon: faRocket, label: 'Foguete', category: 'Transporte' },

  // Educação
  { name: 'faBook', icon: faBook, label: 'Livro', category: 'Educação' },
  { name: 'faGraduationCap', icon: faGraduationCap, label: 'Formatura', category: 'Educação' },
  { name: 'faPen', icon: faPen, label: 'Caneta', category: 'Educação' },
  { name: 'faPencil', icon: faPencil, label: 'Lápis', category: 'Educação' },
  { name: 'faMarker', icon: faMarker, label: 'Marcador', category: 'Educação' },
  { name: 'faHighlighter', icon: faHighlighter, label: 'Marca-texto', category: 'Educação' },

  // Clima
  { name: 'faSun', icon: faSun, label: 'Sol', category: 'Clima' },
  { name: 'faMoon', icon: faMoon, label: 'Lua', category: 'Clima' },
  { name: 'faCloud', icon: faCloud, label: 'Nuvem', category: 'Clima' },
  { name: 'faSnowflake', icon: faSnowflake, label: 'Neve', category: 'Clima' },
  { name: 'faUmbrella', icon: faUmbrella, label: 'Guarda-chuva', category: 'Clima' },
  { name: 'faCloudRain', icon: faCloudRain, label: 'Chuva', category: 'Clima' },

  // Animais
  { name: 'faDog', icon: faDog, label: 'Cachorro', category: 'Animais' },
  { name: 'faCat', icon: faCat, label: 'Gato', category: 'Animais' },
  { name: 'faDove', icon: faDove, label: 'Pomba', category: 'Animais' },
  { name: 'faFish', icon: faFish, label: 'Peixe', category: 'Animais' },
  { name: 'faHorse', icon: faHorse, label: 'Cavalo', category: 'Animais' },
  { name: 'faDragon', icon: faDragon, label: 'Dragão', category: 'Animais' },

  // Natureza
  { name: 'faLeaf', icon: faLeaf, label: 'Folha', category: 'Natureza' },
  { name: 'faTree', icon: faTree, label: 'Árvore', category: 'Natureza' },
  { name: 'faSeedling', icon: faSeedling, label: 'Muda', category: 'Natureza' },
  { name: 'faMountain', icon: faMountain, label: 'Montanha', category: 'Natureza' },
  { name: 'faWater', icon: faWater, label: 'Água', category: 'Natureza' },

  // Roupas
  { name: 'faTshirt', icon: faTshirt, label: 'Camiseta', category: 'Roupas' },
  { name: 'faHatCowboy', icon: faHatCowboy, label: 'Chapéu', category: 'Roupas' },
  { name: 'faGlasses', icon: faGlasses, label: 'Óculos', category: 'Roupas' },
  { name: 'faSocks', icon: faSocks, label: 'Meias', category: 'Roupas' },

  // Jogos & Esportes
  { name: 'faGamepad', icon: faGamepad, label: 'Controle', category: 'Jogos & Esportes' },
  { name: 'faDice', icon: faDice, label: 'Dado', category: 'Jogos & Esportes' },
  { name: 'faPuzzlePiece', icon: faPuzzlePiece, label: 'Quebra-cabeça', category: 'Jogos & Esportes' },
  { name: 'faChess', icon: faChess, label: 'Xadrez', category: 'Jogos & Esportes' },
  { name: 'faBaseball', icon: faBaseball, label: 'Baseball', category: 'Jogos & Esportes' },
  { name: 'faFootball', icon: faFootball, label: 'Futebol', category: 'Jogos & Esportes' },

  // Premiações & Saúde
  { name: 'faMedal', icon: faMedal, label: 'Medalha', category: 'Premiações' },
  { name: 'faTrophy', icon: faTrophy, label: 'Troféu', category: 'Premiações' },
  { name: 'faAward', icon: faAward, label: 'Prêmio', category: 'Premiações' },
  { name: 'faCertificate', icon: faCertificate, label: 'Certificado', category: 'Premiações' },
  { name: 'faRibbon', icon: faRibbon, label: 'Fita', category: 'Premiações' },
  { name: 'faMedkit', icon: faMedkit, label: 'Primeiros socorros', category: 'Premiações' },

  // Expressões
  { name: 'faSmile', icon: faSmile, label: 'Sorriso', category: 'Expressões' },
  { name: 'faLaugh', icon: faLaugh, label: 'Risada', category: 'Expressões' },
  { name: 'faGrinStars', icon: faGrinStars, label: 'Estrelas', category: 'Expressões' },
  { name: 'faKiss', icon: faKiss, label: 'Beijo', category: 'Expressões' },
  { name: 'faHandshake', icon: faHandshake, label: 'Aperto de mão', category: 'Expressões' }
];

const LEGACY_ICON_MAP: Record<string, IconDefinition> = {
  faBrush,
  faShapes,
  faIcons,
  faLightbulb,
  faWandMagicSparkles,
  faPenNib,
  faFeather,
  faCakeCandles,
  faBell,
  faMugHot,
  faCandyCane,
  faHollyBerry,
  faBurger,
  faAppleAlt,
  faCarrot,
  faTags,
  faReceipt,
  faBarcode,
  faCity,
  faShip,
  faCalculator,
  faFlask,
  faMicroscope,
  faHammer,
  faWrench,
  faScrewdriver,
  faPaintRoller,
  faScrewdriverWrench,
  faToolbox,
  faSpa,
  faBug,
  faShirt,
  faRing,
  faClock,
  faShoePrints,
  faSoccerBall,
  faBasketball,
  faVolleyball,
  faDumbbell,
  faCreditCard,
  faCube
};

const OPTION_ICON_MAP: Record<string, IconDefinition> = ICON_OPTIONS.reduce((acc, option) => {
  acc[option.name] = option.icon;
  return acc;
}, {} as Record<string, IconDefinition>);

export const ICON_MAP: Record<string, IconDefinition> = {
  ...LEGACY_ICON_MAP,
  ...OPTION_ICON_MAP,
};

export const DEFAULT_CATEGORY_ICON: IconDefinition = faPalette;
